// extracted by mini-css-extract-plugin
export default {"main":"MainBlock_main__n123z","main_wrap":"MainBlock_main_wrap__hyMzh","main_title":"MainBlock_main_title__mBdjc","main_desc":"MainBlock_main_desc__GrJSg"};